import styled from 'styled-components';

export const UiClassSummary = styled.div`
	display: block;
`;